import { BaseDto } from "@up/data";

export class FloorPlanDto extends BaseDto{
  svgData: string;
  jsonData: string;
  roomId: number;
}
